module.exports = __webpack_public_path__ + "templates/ios-installation-prompt.component.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/installation-prompt/ios-installation-prompt/ios-installation-prompt.component.html
// module id = JCr6
// module chunks = 1